import gql from 'graphql-tag';

export const deleteCommercialContact = gql`
  mutation deleteCommercialContact($id: ID!) {
    deleteCommercialContact(id: $id) {
      value
    }
  }
`;
